import React, { memo } from 'react';

import styled from 'styled-components';

// import SelectedOptionsBar from '../SelectedOptionsBar';
import SelectedOptionsTable from '../SelectedOptionsTable';
const SelectedOptions = (props) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const { optionData } = props;
  const handleChangePageSize = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  return (
    <Container>
      {/* <SelectedOptionsBar /> */}
      <SelectedOptionsTable
        optionData={optionData}
        page={currentPage}
        pageSize={pageSize}
        setPageSize={handleChangePageSize}
        setPage={setCurrentPage}
        setApiData={props.setApiData}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding: 0 48px;
`;

export default memo(SelectedOptions);
